import { Button, FormControl, Grid, Input, Option, Select, Sheet, Table } from "@mui/joy";
import React from "react";
import BuildingDialog from "../Dialogs/BuildingDialog";
import { Util } from "../Helpers/Util";
import { useRole, isAdminRole } from "../Contexts/RoleContext";
export interface Building {
	Name: string;
	ID: string;
	Address1: string;
	Address2: string;
	City: string;
	State: string;
	Zip: string;
	Active: boolean;
	PrimaryContact: string;
	Latitude?: number | null;
	Longitude?: number | null;
}

interface BuildingListProps {
	selectBuilding: Function;
	defaultBuilding: string | undefined;
	hide: Function;
}

export default function BuildingList(props: BuildingListProps) {
	const [buildings, setBuildings] = React.useState([] as Array<Building>);
	const [nameFilter, setNameFilter] = React.useState("");
	const [addNew, setAddNew] = React.useState(false);
	const [filter, setFilter] = React.useState<Boolean | null>(true);
	const { effectiveRole } = useRole();

	React.useEffect(() => {
		getBuildings();
	}, [props.defaultBuilding, addNew, filter, effectiveRole]);

	const getBuildings = () => {
		fetch(isAdminRole(effectiveRole) ? "/Building/GetBuildingsList" : "/Building/GetClientPortalBuildings", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ filter: filter }),
		})
			.then((x) => x.json())
			.then((x) => {
				const hadBuildings = buildings.length > 0;
				const bs = x
					.sort((a: any, b: any) => a.building_name.localeCompare(b.building_name))
					.map((y: any) => {
						return { Name: y.building_name, ID: y.buildings_id } as Building;
					});
				setBuildings(bs);

				if (!hadBuildings) {
					if (x.length === 1) {
						const y = x[0];
						props.hide();
						selectBuilding({ Name: y.building_name, ID: y.buildings_id } as Building);
					} else if (props.defaultBuilding) {
						selectBuilding(bs.find((b: Building) => b.ID === props.defaultBuilding));
					} else {
						const y = x[0];
						selectBuilding({ Name: y.building_name, ID: y.buildings_id } as Building);
					}
				}
			});
	};

	const selectBuilding = (b: Building) => {
		props.selectBuilding(b);
	};

	return (
		<>
			<BuildingDialog
				open={addNew}
				close={(bid: string) => {
					setAddNew(false);
					if (bid) props.selectBuilding({ ID: bid } as Building);
				}}
			/>
			<Sheet sx={{ borderRadius: "sm", boxShadow: "md", p: 1 }}>
				<Table stripe="even" sx={{ "--TableCell-height": "20px" }} hoverRow={true}>
					<thead>
						<tr>
							<th>
								<Grid container rowSpacing={1}>
									<Grid xs={12}>
										<FormControl>
											<Input size="sm" name="name" placeholder="Search..." onChange={(event) => setNameFilter(event.target.value)}></Input>
										</FormControl>
									</Grid>
									{isAdminRole(effectiveRole) && (
										<>
											<Grid xs={12}>
												<Button fullWidth onClick={() => setAddNew(true)}>
													New Building
												</Button>
											</Grid>
											<Grid xs={12}>
												<Select size="sm" defaultValue={filter} onChange={(event, value) => setFilter(value)}>
													<Option value={true}>Show Active</Option>
													<Option value={false}>Show Inactive</Option>
													<Option value={null}>Show All</Option>
												</Select>
											</Grid>
										</>
									)}
								</Grid>
							</th>
						</tr>
					</thead>
					<tbody>
						{buildings
							.filter((x) => {
								return Util.isNullOrEmpty(nameFilter.trim()) ? true : x.Name.toLocaleLowerCase().includes(nameFilter.toLocaleLowerCase());
							})
							.map((x) => (
								<tr style={{ cursor: "pointer" }} onClick={() => selectBuilding(x)}>
									<td>{x.Name}</td>
								</tr>
							))}
					</tbody>
				</Table>
			</Sheet>
		</>
	);
}
